// Copyright (c) 2016 Deere & Company

import {
    closeDealerRecommendationModal,
    openDealerRecommendationModal
} from './dealer-recommendation-modal';
import {
    getDealerRecommendations,
    resetSelectedDealerRecommendations,
    toggleSelectAll,
    updateDealerRecommendationCheckBox,
    updateRecommendationComment
} from './dealer-recommendation';
import {
    resetTransferResults,
    updateTransferResultsWithFacets
} from './facet-updates';
import {
    selectAllDealersOnInitialLoad,
    toggleTransferApprovalFacetItems,
    updateDealerAccountFacetInput,
    updateTransferApprovalFacetItem
} from './facets';
import {
    updateReview,
    updateTransferRequest
} from './update-dealer-recommendation';
import {exportToExcel} from './export-to-excel';
import {highRentalDaysExportToExcel} from '../../shared/action-creators/high-rental-days-export-to-excel.js';
import sharedActionCreators from '../../shared/action-creators';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion';
import {transferAllDealerRecommendation} from './transfer-all-dealer-recommendation';
import {updateFactoryDuplicatePinPlateResults} from '../../factory-users-duplicate-pin-plate/action-creators/factory-duplicate-pin-plates.js';
import {updateRecommendationListFilterBy} from './update-recommendation-list-filter-by';
import {updateRegistrationResults} from '../../registration-review/action-creators/registration';
export default {
    closeDealerRecommendationModal,
    exportToExcel,
    getDealerRecommendations,
    ...sharedActionCreators,
    highRentalDaysExportToExcel,
    openDealerRecommendationModal,
    resetSelectedDealerRecommendations,
    resetTransferResults,
    selectAllDealersOnInitialLoad,
    toggleReportsAccordion,
    toggleSelectAll,
    toggleTransferApprovalFacetItems,
    transferAllDealerRecommendation,
    updateDealerAccountFacetInput,
    updateDealerRecommendationCheckBox,
    updateFactoryDuplicatePinPlateResults,
    updateRecommendationComment,
    updateRecommendationListFilterBy,
    updateRegistrationResults,
    updateReview,
    updateTransferApprovalFacetItem,
    updateTransferRequest,
    updateTransferResultsWithFacets
};



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/action-creators/index.js